import { TreeItem } from './getTreeData';

export const getIndeterminate = (selected: string[], treeData: TreeItem[]) => {
  const indeterminate = [] as string[];

  treeData.forEach(({ id, children }) => {
    indeterminate.push(...getIndeterminate(selected, children));

    const selectedChildrenAmount = children.filter(({ id }) =>
      selected.includes(id)
    ).length;

    if (selectedChildrenAmount && selectedChildrenAmount !== children.length)
      indeterminate.push(id);

    const indeterminateChildrenAmount = children.filter(({ id }) =>
      indeterminate.includes(id)
    ).length;

    if (!!indeterminateChildrenAmount) indeterminate.push(id);
  });

  return indeterminate;
};

export const getFullSelected = (selected: string[], treeData: TreeItem[]) => {
  const fullSelected = [] as string[];

  treeData.forEach(({ id, children }) => {
    fullSelected.push(...getFullSelected(selected, children));

    const selectedChildrenAmount = children.filter(({ id }) =>
      [...selected, ...fullSelected].includes(id)
    ).length;

    if (selectedChildrenAmount && selectedChildrenAmount === children.length)
      fullSelected.push(id);
  });

  return fullSelected;
};
